<template>
  <div>
    <Head title="Formularios" />
    <div class="flex flex-wrap items-center justify-between mb-6">
      <h1 class="text-3xl font-bold">Formularios {{ dateString }} </h1>
      <div class="flex w-100 mb-2 md:mb-0">
        <VueDatePicker v-model="datePickerDate" placeholder="Filtrar por fecha" month-picker locale="es" auto-apply :clearable="false" />
      </div>
      <div class="flex">
        <form v-if="auth.user.role_id == 1" @submit.prevent="send">
          <button class="btn-orange ml-auto mr-2" type="submit">Enviar emails recordatorio</button>
        </form>
        <form v-if="auth.user.role_id == 1" @submit.prevent="generate">
          <button class="btn-indigo ml-auto" type="submit">Generar formularios</button>
        </form>
        <a :href="`/exportar/${date}`" class="btn-indigo ml-2" target="_self">
          Exportar mes actual
        </a>
        <a href="/exportar" class="btn-orange ml-2" target="_self">
          Exportar
        </a>
      </div>
    </div>
    <div>
      <div class="rounded overflow-hidden bg-white mb-4 shadow-lg">
        <div class="px-6 py-4">
          <table>
            <tr>
              <td class="py-2">
                <Link href="?form=active">
                  <span class="font-bold hover:text-orange-500">Total de formularios por rellenar:</span>
                </Link>
              </td>
              <td class="pl-4">{{ formsActive }}</td>
            </tr>
            <tr>
              <td class="py-2">
                <Link href="?form=edited">
                  <span class="font-bold hover:text-orange-500">Total de formularios editados:</span>
                </Link>
              </td>
              <td class="pl-4">{{ formsEdited }}</td>
            </tr>
            <tr>
              <td class="py-2">
                <Link href="?form=delivered">
                  <span class="font-bold hover:text-orange-500">Total de formularios entregados:</span>
                </Link>
              </td>
              <td class="pl-4">{{ formsInactive }}</td>
            </tr>
            <tr>
              <td class="py-2">
                <Link href="?form=all">
                  <span class="font-bold hover:text-orange-500">Total de formularios:</span>
                </Link>
              </td>
              <td class="pl-4">{{ totalForms }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Fecha</th>
            <th class="pb-4 pt-6 px-6">Oficina</th>
            <th class="pb-4 pt-6 px-6">Código BDT</th>
            <th class="pb-4 pt-6 px-6">Entrega</th>
            <th class="pb-4 pt-6 px-6">Editado por</th>
            <th class="pb-4 pt-6 px-6">Fecha edición</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="formEntry in forms.data" :key="formEntry.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <template v-if="formEntry.without_forms !== true">
              <td class="border-t">
                <Link class="flex items-center px-6 py-4 focus:text-orange-500" :href="`/formularios/${formEntry.id}/editar`">
                  {{ formEntry.date }}
                  <icon v-if="formEntry.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="`/formularios/${formEntry.id}/editar`" tabindex="-1">
                  {{ formEntry.organization }} <icon v-if="formEntry?.sof_deleted === true" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="`/formularios/${formEntry.id}/editar`" tabindex="-1">
                  {{ formEntry.codeBDT }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="`/formularios/${formEntry.id}/editar`" tabindex="-1">
                <span v-if="formEntry.active == '0'" class="px-4 py-2 rounded-full text-green-500 bg-green-200 font-semibold text-sm flex align-center w-max cursor-pointer active:bg-gray-300 transition duration-300 ease">
                  Formulario entregado
                </span>
                  <span v-if="formEntry.active == '1'" class="px-4 py-2 rounded-full text-red-500 bg-red-200 font-semibold text-sm flex align-center w-max cursor-pointer active:bg-gray-300 transition duration-300 ease">
                  Formulario sin entregar
                </span>
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="`/formularios/${formEntry.id}/editar`" tabindex="-1">
                  {{ formEntry.user ? formEntry.user.email : '-' }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="`/formularios/${formEntry.id}/editar`" tabindex="-1">
                  {{ formEntry.created_at ? formEntry.updated_at : '-' }}
                </Link>
              </td>
              <td class="w-px border-t">
                <Link class="flex items-center px-4" :href="`/formularios/${formEntry.id}/editar`" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </template>

          </tr>
          <tr v-if="forms.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No se han encontrado formularios.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="forms.links" />
  </div>
</template>

<script>
import { ref } from 'vue'
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    VueDatePicker,
  },
  layout: Layout,
  props: {
    forms: Object,
    date: String,
    formsActive: Number,
    formsEdited: Number,
    formsInactive: Number,
    totalForms: Number,
    auth: Object,
  },

  data() {
    return {
      dateString: '',
      datePickerDate: ref({
        month: this.date.split('-')[0] - 1,
        year: this.date.split('-')[1],
      }),
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/formularios', pickBy(this.form), { preserveState: true })
      }, 150),
    },
    datePickerDate: {
      deep: true,
      handler: throttle(function () {
        var tzoffset = (new Date()).getTimezoneOffset() * 60000
        let dateForm = new Date(new Date(this.datePickerDate.year, this.datePickerDate.month) - tzoffset)
        let year = dateForm.getFullYear()
        let month = dateForm.getMonth() + 1
        this.$inertia.get(`/formularios/${month}-${year}`)
      }, 150),
    },
  },
  mounted() {
    let dateArray = this.date.toString().split('-')
    this.setCurrentMonth(new Date(dateArray[1], dateArray[0] - 1))
  },
  methods: {
    generate() {
      this.$inertia.post('/formularios/generar')
    },
    send() {
      this.$inertia.post('/enviar')
    },
    getUserName(user) {
      return user.first_name + ' ' + user.last_name
    },
    setCurrentMonth(date) {
      const month = date.toLocaleString('default', { month: 'long' })
      const year = date.getFullYear()
      this.dateString = month + ' ' + year
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
